// extracted by mini-css-extract-plugin
export default {"darkButton":"ThemeButton_darkButton__Kg-Y-","lightButton":"ThemeButton_lightButton__KARuu"};